export default __webpack_public_path__ + "static/media/support.6da4eb90.jpg";